import { Add } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useState } from 'react';
import Modal from '../../elements/Modal';
import ProductProviderForm from './ProductProviderForm';

export default function AddProductLinks({
  fetchData,
  product,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);
    try {
      const formData = new FormData();
      formData.append('url', values.url);
      formData.append('productId', product.id);
      formData.append(
        'providerName',
        values.provider === 'other' ? values.otherProvider : values.provider
      );
      const priceWithoutCommas = values.price.replace(/,/g, '');
      formData.append('price', priceWithoutCommas);
      formData.append('reviewCount', values.reviewCount || 0);
      formData.append('rating', values.rating || 0);
      formData.append('otherProvider', values.otherProvider);
      formData.append('reviewUrl', values.reviewUrl);
      formData.append('image', values.icon);

      
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/scraper/add`,
        {
          method: 'POST',
          body: formData,
          headers: { Authorization: token },
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Store added successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(error.message || 'Failed to add store');
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <IconButton variant="text" onClick={handleClickOpen}>
        <Add />
      </IconButton>
      <Modal
        open={open}
        modalTitle="Add links"
        handleClose={handleClose}
        width={'md'}>
        {error && (
          <Alert severity="error" sx={{ mb: '15px' }}>
            {error}
          </Alert>
        )}
        <ProductProviderForm
          onSubmit={handleSubmit}
          product={product}
          setError={setError}
          token={token}
        />
      </Modal>
    </>
  );
}
